import ut from "../../assets/images/ut2020.png"
import acc from "../../assets/images/acc2017.png"
export const schools = [
    {
        school: "The University of Texas at Austin",
        image: ut,
        degree: "Bachelor of Science in Computer Science",
        link:"https://drive.google.com/file/d/1slHABq5W9A7Tb5XMV2VN8x_MLjD6YEkQ/view?usp=sharing", 
        schoolLink:"https://www.utexas.edu/",
        courses:{
            computerScience:[
                "Cyberphysical Systems",
                "Introduction to Computer Security",
                "Contemporary Issues in Computer Science",
                "Modern Web Applications",
                "Computer Networks",
                "Research In Computer Architecture",
                "Object Oriented Programing",
                "Algorithms",
                "Programming for Correctness/Performance",
                "Operating Systems",
                "Computer Architecture",
            ],
            math:[
                "Probability",
                "Linear Algebra",
                "Discrete Math"
            ],
            science: ["Geology"],
            other:[
                "The Rise of Christianity",
                "Intro to The New Testament",
                "Jazz Appreciation",
                "Leadership Stories",
                "Sleep, Are We Getting Enough?"
            ]
        },
        gradDate: "May 2020",
        tools:["Java", "Python", "C++", "C", "Bash"]
    },
    {
        school: "Austin Community College",
        image: acc,
        link:"https://drive.google.com/file/d/16SiIFbwflKyTFERyGt1KcnzBI8tvwssU/view?usp=sharing", 
        schoolLink:"https://www.austincc.edu/",
        degree: "Associate of Science in Computer Science",
        courses:{
            computerScience:[
                "Data Structures",
                "Programming Fundamentals II",
                "Programming Fundamnetals I",
                "Intro to Computing"
            ],
            math:[
                "Calculus 3 (Multivariable)",
                "Calculus 2 (Integral)",
                "Calculus 1 (Differential)",
                "Trigenometry"
            ],
            science: [
                "Chemistry 2",
                "Chemistry 2 Lab",
                "Chemistry 1",
                "Chemistry 1 Lab"
            ],
            other:[
                "US Government",
                "Texas Government",
                "English Composition 2",
                "English Composition 1",
                "US History 2",
                "US History 1",
                "Interpersonal Communication",
                "Introduction to Psychology",
                "Introduction to Philosophy"
            ]
        },
        gradDate: "May 2017",
        tools:["Python", "C++"]
    },
]
